<template>
  <div class="pollen">
    <!-- 花粉监测列表 -->
    <div class="list1" @click="dianji()">
      <!-- 图标 -->
      <span>
        <img src="./imgs/jiance.png" alt />花粉监测
      </span>
      <!-- 箭头 -->
      <span>
        <i
          class="el-icon-arrow-down"
          style="color:#6694C8;font-weight: 700;"
          :class="flag==1?'clk':''"
        ></i>
      </span>
    </div>
    <!-- 花粉监测详情 -->
    <el-collapse-transition>
      <div v-if="show">
        <div class="jiance">
          <p>花粉观测数据</p>
          <p>(北京每年花粉季为3至9月)</p>
          <p>本数据由北京市气象局和北京同仁医院共同发布</p>
          <p>最新观测时间:{{zxtime}}</p>
          <div id="ec"></div>
          <div class="table">
            <table>
              <tr>
                <td>
                  花粉数量
                  <br />（粒/千平方毫米）
                </td>
                <td>花粉浓度</td>
              </tr>
              <tr>
                <td>&lt;=50</td>
                <td>很低</td>
              </tr>
              <tr>
                <td>51~100</td>
                <td>较低</td>
              </tr>
              <tr>
                <td>101~300</td>
                <td>偏高</td>
              </tr>
              <tr>
                <td>301~500</td>
                <td>较高</td>
              </tr>
              <tr>
                <td>501~800</td>
                <td>很高</td>
              </tr>
              <tr>
                <td>>=801</td>
                <td>极高</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </el-collapse-transition>
    <!-- 花粉预报列表 -->
    <div class="list2" @click="dianji1()">
      <!-- 图标 -->
      <span>
        <img src="./imgs/yubao.png" alt />花粉预报
      </span>
      <!-- 箭头 -->
      <span>
        <i
          class="el-icon-arrow-down"
          style="color:#6694C8;font-weight: 700;"
          :class="flag1==1?'clk':''"
        ></i>
      </span>
    </div>
    <!-- 花粉预报详情 -->
    <el-collapse-transition>
      <div v-if="show1">
        <div class="yubao">
            <div class="but">
                <ul>
                    <li v-for="(item,index) in butlist" :key="index" :class="index==anniu?'pitchOn':''" @click="but(index)">{{item}}</li>
                </ul>
                <p class="p">|</p>
                <p class="p1">|</p>
            </div>
            <div class="yujing">
                <img :src="imgsrc" alt="">
                <ul>
                  <li>
                    <p>一级</p>
                  </li>
                  
                  <li>
                    <p>二级</p>
                  </li>
                  
                  <li>
                    <p>三级</p>
                  </li>
                  
                  <li>
                    <p>四级</p>
                  </li>
                  
                  <li>
                    <p>五级</p>
                  </li>
                  
                  <li>
                    <p>六级</p>
                  </li>
                </ul>
            </div>
        </div>
      </div>
    </el-collapse-transition>
  </div>
</template>
<script>
import Vue from "vue";
// 引入echarts
import echarts from "echarts";
Vue.prototype.$echarts = echarts;
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      // 标志位
      flag: 1,
      flag1: "",
      // 显示隐藏
      show: true,
      show1: false,
      butlist:['未来24小时','未来48小时','未来72小时'],
      anniu:0,
      imgsrc:'/pic/pollen/pollenproduct_024.png',
      // 最新时间
      zxtime:'',
      ybtime:''
    };
  },
  mounted() {
    this.request()
  },
  methods: {
    echart2(id,datas) {
      var ele = document.getElementById(id);
      var myChart = echarts.init(ele);
      var option = {
        legend: {
          align: "left",
          textStyle: {
            color: "#000",
            fontSize: 10,
          },
          itemWidth: 18,
          itemHeight: 9,
        },
        tooltip: {
          trigger: "axis",
          // 坐标轴指示器，坐标轴触发有效
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "2%",
          right: "5%",
          bottom: "2%",
          top: "18%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
          //坐标轴刻度标签的相关设置。
          axisLabel: {
            // interval: 0,
            textStyle: {
              color: "#078ceb",
              fontSize: 10,
              align: "center",
            },
          },
          //坐标轴轴线相关设置
          axisLine: {
            lineStyle: {
              color: "black",
              opacity: 0.2,
            },
          },
          //坐标轴在 grid 区域中的分隔线。
          splitLine: {
            show: true,
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            textStyle: {
              color: "#078ceb",
              fontSize: 10,
            },
          },
          axisLine: {
            lineStyle: {
              color: "#000",
            },
          },
          splitLine: {
            show: true,
          },
        },
        series: [
          {
            data: [],
            type: "line",
            smooth: true,
            name: "海淀",
            //图形样式
            itemStyle: {
              normal: {
                color: "#EF5353",
              },
            },
          },
          {
            data: [80, 92, 91, 94, 120, 130, 120],
            type: "line",
            smooth: true,
            name: "朝阳",
            //图形样式
            itemStyle: {
              normal: {
                color: "#3AB54E",
              },
            },
          },
          {
            data: [60, 332, 51, 92, 14, 190, 120],
            type: "line",
            smooth: true,
            name: "石景山",
            //图形样式
            itemStyle: {
              normal: {
                color: "#F39800",
              },
            },
          },
          {
            data: [60, 332, 51, 92, 14, 190, 120],
            type: "line",
            smooth: true,
            name: "丰台",
            //图形样式
            itemStyle: {
              normal: {
                color: "red",
              },
            },
          },
          {
            data: [60, 332, 51, 92, 14, 190, 120],
            type: "line",
            smooth: true,
            name: "昌平",
            //图形样式
            itemStyle: {
              normal: {
                color: "#8957A1",
              },
            },
          },
          {
            data: [60, 332, 51, 92, 14, 190, 120],
            type: "line",
            smooth: true,
            name: "顺义",
            //图形样式
            itemStyle: {
              normal: {
                color: "#13B5B1",
              },
            },
          },
        ],
      };
      var arr1=[]
      for(var i=0;i<7;i++){
        var x=moment(this.zxtime,'YYYY-MM-DD').add(-[i],'day').format('MMDD')
        arr1.push(x)
        arr1.sort((a, b) => {
          return (
            a-b
          )
        });
      }
      for(var a=0;a<arr1.length;a++){
        option.xAxis.data.push(moment(arr1[a],'MMDD').format('MM-DD'))
      }
      var arr2=[]
      var haidian=[]
      var chaoyang=[]
      var shijingshan=[]
      var fengtai=[]
      var changping=[]
      var shunyi=[]
      var arrList=[]
      // const minDt = moment(datas.DS.slice(-1)[0]['1.58.0.1.11'], 'YYYY-MM-DD HH:mm:ss')
      // const maxDt = moment(datas.DS[0]['1.58.0.1.11'], 'YYYY-MM-DD HH:mm:ss')
      // const day = (maxDt.unix() - minDt.unix()) / 60 / 60 / 24
      
      // const fillDtList = new Array(day).fill(null).map((d, i) => minDt.clone().add(i, 'days').format('YYYY-MM-DD HH:mm:ss'))
      // fillDtList.push(maxDt.format('YYYY-MM-DD HH:mm:ss'))
      
      for(var b=0;b<70;b++){
        arr2.push(Object.values(datas.DS[b]))
        arr2.sort((a, b) => {
          return (
            moment(b[0],"YYYY-MM-DD HH:mm:ss").format("YYYYMMDD")-moment(a[0],"YYYY-MM-DD HH:mm:ss").format("YYYYMMDD")
          )
        });
        var y=moment(arr2[0][0],"YYYY-MM-DD HH:mm:ss").add(-8,'day').format("YYYY-MM-DD HH:mm:ss")
        if(arr2[b][0]>y){
          // arrList.push(arr2[b][0])
          // var arrList1=[...new Set(arrList)]
          if(arr2[b][1]=="54399"){
            // 海淀
            haidian.push(arr2[b][2]*2)
          }else if(arr2[b][1]=="54433"){
            // 朝阳
            chaoyang.push(arr2[b][2]*2)
          }else if(arr2[b][1]=="54513"){
            // 石景山
            shijingshan.push(arr2[b][2]*2)
          }else if(arr2[b][1]=="54514"){
            // 丰台
            fengtai.push(arr2[b][2]*2)
          }else if(arr2[b][1]=="54499"){
            // 昌平
            changping.push(arr2[b][2]*2)
          }else if(arr2[b][1]=="54398"){
            // 顺义
            shunyi.push(arr2[b][2]*2)
          }
        }
      }
      option.series[0].data=haidian.reverse()
      option.series[1].data=chaoyang.reverse()
      option.series[2].data=shijingshan.reverse()
      option.series[3].data=fengtai.reverse()
      option.series[4].data=changping.reverse()
      option.series[5].data=shunyi.reverse()
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    // 列表1点击
    dianji() {
      this.show1 = false;
      this.flag1 = "";
      if (this.flag == 1) {
        this.flag = "";
        this.show = false;
      } else {
        this.flag = 1;
        this.show = true;
        this.request()
      }
    },
    // 列表2点击
    dianji1() {
      // this.request2()
      this.show = false;
      this.flag = "";
      this.anniu=0;
      if (this.flag1 == "") {
        this.flag1 = 1;
        this.show1 = true;
      } else {
        this.flag1 = "";
        this.show1 = false;
      }
    },
    // 按钮点击
    but(idx) {
      this.anniu = idx;
      if(idx==0){
        this.imgsrc='/pic/pollen/pollenproduct_024.png'
      }else if(idx==1){
        this.imgsrc='/pic/pollen/pollenproduct_048.png'
      }else if(idx==2){
        this.imgsrc='/pic/pollen/pollenproduct_072.png'
      }
    },
    // 花粉监测数据请求
    request(jctime){
      axios.get("/data/pollen/pollen.json").then((res) => {
        var datas=res.data
        var arr=[]
        for(var i=0;i<70;i++){
          arr.push(Object.values(res.data.DS[i]))
        }
        this.zxtime=moment(arr[0][0],"YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD")
        this.echart2("ec",datas);
      })
    },
  },
};
</script>
<style lang="less" scoped>
.pitchOn{
    background-color: #82C0F6!important;
    color:#fff!important;
}
.clk {
  transform: rotate(-180deg);
}
.bj {
  background-color: #63b0e5;
}
.pollen {
  height: 100%;
  background-color: #f5f5f5;
  .list1,
  .list2 {
    height: 110px;
    background-color: #fbfbfb;
    border-bottom: 1px solid #d3d3d3;
    span:nth-child(1) {
      float: left;
      display: flex;
      align-items: center;
      width: 280px;
      height: 100%;
      font-size: 35px;
      color: #131313;
      margin-left: 40px;
      img {
        height: 70%;
        margin-right: 15px;
      }
    }
    span:nth-child(2) {
      float: right;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100px;
      height: 100%;
    }
  }
  .jiance {
    height: 1000px;
    overflow: auto;
    border-bottom: 1px solid #d3d3d3;
    p {
      height: 6%;
      font-size: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 3%;
    }
    p:nth-child(4) {
      background-color: #ffff66;
    }
    #ec {
      margin: auto;
      height: 46%;
      width: 90%;
    }
    .table {
      height: 40%;
      width: 68%;
      margin: auto;
      margin-top:2%;
      font-size: 20px;
      table {
        border-collapse: collapse;
        height: 100%;
        width: 100%;
        border: 1px solid #6894ca;
        tr {
          td {
            width: 50%;
            text-align: center;
            border: 1px solid #2a74ce;
          }
        }
        tr:nth-child(1) {
          height: 20%;
          background-color: #6894ca;
        }
      }
    }
  }
  .yubao {
    height: 1000px;
    overflow: auto;
    .but{
        height:6%;
        display: flex;
        background-color: #fff;
        border-bottom:1px solid #f5f0f0;
        position: relative;
        ul{
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        li{
            font-size: 30px;
            margin-left:4%;
            color:#82C0F6;
            width: 23%;
            text-align: center;
        }
        .p{
            position: absolute;
            color:#82C0F6;
            left: 38%;
            top: 9%;
            font-size: 35px;
        }
        .p1{
            position: absolute;
            color:#82C0F6;
            left: 65%;
            top: 10%;
            font-size: 35px;
        }
    }
    .yujing{
        width:100%;
        position: relative;
        img{
            width:100%;
        }
        ul{
          right:20px;
          bottom:50px;
          position: absolute;
          li{
            width:40px;
            height:30px;
            margin-top:15px;
            p{
              position: relative;
              font-size: 25px;
              width:100px;
              left:-60px;
              top:-2px;
            }
          }
          li:nth-child(1){
            background-color: #29F021;
          }
          li:nth-child(2){
              background-color: #9AE803;
          }
          li:nth-child(3){
              background-color: #FAFF2C;
          }
          li:nth-child(4){
              background-color: #FC8330;
          }
          li:nth-child(5){
              background-color: #FB2C2A;
          }
          li:nth-child(6){
              background-color: #992D4C;
          }
        }
    }
  }
}
</style>